import React, { useState } from "react";
import clsx from "clsx";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import routes from "common/routes";
import AppPage from "components/AppPage";
import AppPageHeader from "components/AppPageHeader";
import AppPageContent from "components/AppPageContent";
import AccountPageProfile from "./AccountPageProfile";

import useStyles from "./styles";

const componentsRegister = {
  AccountPageProfile: AccountPageProfile
};
type TabPops = {
  value: string;
  label: string;
  href?: string;
};

type Component = {
  componentName: string;
  className: string;
  componentProps: any;
};

type Tab = {
  name: string;
  tabProps: TabPops;
  component: Component;
};

const tabs: Tab[] = [
  {
    name: "profile",
    tabProps: {
      value: "profile",
      label: "My Profile",
      href: routes.account.path
    },
    component: {
      componentName: "AccountPageProfile",
      componentProps: {},
      className: ""
    }
  }
];

const AccountPage = () => {
  const classes = useStyles();

  const [selectedTab, setSelectedTab] = useState<string>(tabs[0].name);

  const handleTabChange = (
    event: React.ChangeEvent<{ value: string }>,
    value: string
  ) => {
    event.preventDefault();
    setSelectedTab(value);
  };

  const getComponent = selectedTab => {
    const selectedTabData = tabs.find(tab => tab.name === selectedTab);
    const { componentName, componentProps } = selectedTabData.component;
    const Component = componentsRegister[componentName];

    return <Component {...componentProps} />;
  };

  return (
    <AppPage>
      <AppPageHeader>
        <Tabs
          className={classes.tabs}
          value={selectedTab}
          onChange={handleTabChange}
        >
          {tabs.length &&
            tabs.map((tab, index) => {
              return (
                <Tab key={index} className={classes.tab} {...tab.tabProps} />
              );
            })}
        </Tabs>
      </AppPageHeader>
      <AppPageContent className={clsx(classes.pageContent, "centeredContent")}>
        {selectedTab && getComponent(selectedTab)}
      </AppPageContent>
    </AppPage>
  );
};

export default AccountPage;
